import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useWalletValue } from '@frontend/hooks/useWalletValue';
import { usePlatform } from '@frontend/providers/PlatformProvider';
import { createContext, useContext } from 'react';
var initialState = {
  loading: false,
  coinList: {}
};
var CoinPriceContext = /*#__PURE__*/createContext(_objectSpread(_objectSpread({}, initialState), {}, {
  refetch: function refetch() {
    return null;
  }
}));
export var useCoinPriceContext = function useCoinPriceContext() {
  return useContext(CoinPriceContext);
};
export var CoinPriceProvider = function CoinPriceProvider(_ref) {
  var children = _ref.children;

  var _usePlatform = usePlatform(),
      tokens = _usePlatform.tokens;

  var _useWalletValue = useWalletValue(initialState, /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(setValue) {
      var _yield$import, getPrices, coinList;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setValue(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  loading: true
                });
              });
              _context.next = 3;
              return import('@jdiyield/contracts');

            case 3:
              _yield$import = _context.sent;
              getPrices = _yield$import.getPrices;
              _context.next = 7;
              return getPrices(tokens);

            case 7:
              coinList = _context.sent;
              setValue(function () {
                return {
                  coinList: coinList,
                  loading: false
                };
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []),
      _useWalletValue2 = _slicedToArray(_useWalletValue, 2),
      _useWalletValue2$ = _useWalletValue2[0],
      coinList = _useWalletValue2$.coinList,
      loading = _useWalletValue2$.loading,
      refetch = _useWalletValue2[1].refetch;

  var handleRefetch = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (loading) {
                _context2.next = 3;
                break;
              }

              _context2.next = 3;
              return refetch();

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleRefetch() {
      return _ref3.apply(this, arguments);
    };
  }();

  return _jsx(CoinPriceContext.Provider, {
    value: {
      coinList: coinList,
      loading: loading,
      refetch: handleRefetch
    },
    children: children
  });
};